import { render, staticRenderFns } from "./localized.vue?vue&type=template&id=55bd9f8f"
import script from "./localized.vue?vue&type=script&lang=js"
export * from "./localized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports